import type { Assembly } from '@app/modules/s3-upload/models/assembly'

import type { MessagePhotoAlbumPhoto } from './message-photo-album-photo.model'

export const MESSAGE_PHOTO_ALBUM_SECTIONS = ['approved', 'pending'] as const
export type MessagePhotoAlbumSection = (typeof MESSAGE_PHOTO_ALBUM_SECTIONS)[number]

export interface GetPhotosResponse {
  message_album_photos: MessagePhotoAlbumPhoto[]
  total_pages: number
}

export interface GetPhotosParams {
  page: number
  type: MessagePhotoAlbumSection
}

export interface UploadPhotosParams {
  transloadit: Assembly
  successful: string[]
  profile_browse_id: string
}

export interface UploadPhotosResponse {
  media: MessagePhotoAlbumPhoto[]
}
